import { render, staticRenderFns } from "./List.vue?vue&type=template&id=96a420a0&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=96a420a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a420a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a420a0')) {
      api.createRecord('96a420a0', component.options)
    } else {
      api.reload('96a420a0', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=96a420a0&scoped=true", function () {
      api.rerender('96a420a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/IntelligentInvestmentAssistant/components/List.vue"
export default component.exports